const SUPPORT_ENTITY_ID_PATTERN = /^[a-z0-9][a-z0-9._:/-]{0,239}$/i;

export function safeSupportTicketEntityId(value) {
  if (typeof value !== "string" && typeof value !== "number") return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return SUPPORT_ENTITY_ID_PATTERN.test(text) ? text : "";
}

function parsedRequestBody(body) {
  if (!body) return null;
  if (typeof FormData !== "undefined" && body instanceof FormData) return body;
  if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) return body;
  if (typeof body === "string") {
    if (body.length > 100_000) return null;
    try {
      const parsed = JSON.parse(body);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }
  return typeof body === "object" && !Array.isArray(body) ? body : null;
}

function bodyValue(body, ...keys) {
  if (!body) return undefined;
  if (
    (typeof FormData !== "undefined" && body instanceof FormData)
    || (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams)
  ) {
    for (const key of keys) {
      const value = body.get(key);
      if (value !== null && value !== undefined && String(value).trim()) return value;
    }
    return undefined;
  }
  for (const key of keys) {
    const value = body[key];
    if (value !== null && value !== undefined && String(value).trim()) return value;
  }
  return undefined;
}

function isKeyValueBody(body) {
  return (typeof FormData !== "undefined" && body instanceof FormData)
    || (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams);
}

function requestUrl(value) {
  try {
    return new URL(String(value || ""), "https://ranchpower.invalid");
  } catch {
    return new URL("https://ranchpower.invalid/");
  }
}

// Extract only bounded, non-secret business identifiers. The complete request
// body must never be copied into a support ticket. Path-aware `id` handling is
// intentionally limited to customer/order endpoints because a generic `id`
// can mean a payment, task, upload, or other unrelated record.
export function supportTicketEntityScope(path, body) {
  const parsed = parsedRequestBody(body);
  const url = requestUrl(path);
  const pathname = url.pathname.toLowerCase();
  const nestedOrder = parsed && !isKeyValueBody(parsed)
    ? parsed.order
    : null;
  const nestedCustomer = parsed && !isKeyValueBody(parsed)
    ? parsed.customer
    : null;
  let orderId = safeSupportTicketEntityId(
    bodyValue(parsed, "orderId", "order_id")
      || (nestedOrder && nestedOrder.id)
      || (/^\/api\//.test(pathname) && (url.searchParams.get("orderId") || url.searchParams.get("order_id")))
  );
  let customerId = safeSupportTicketEntityId(
    bodyValue(parsed, "customerId", "customer_id")
      || (nestedCustomer && nestedCustomer.id)
      || (/^\/api\//.test(pathname) && (url.searchParams.get("customerId") || url.searchParams.get("customer_id")))
  );

  if (!orderId && /^\/api\/orders(?:\/|$)/.test(pathname)) {
    orderId = safeSupportTicketEntityId(bodyValue(parsed, "id") || url.searchParams.get("id"));
  }
  if (!customerId && /^\/api\/customers(?:\/|$)/.test(pathname)) {
    customerId = safeSupportTicketEntityId(bodyValue(parsed, "id") || url.searchParams.get("id"));
  }
  if (!orderId && pathname === "/api/invoices/pdf") {
    orderId = safeSupportTicketEntityId(url.searchParams.get("id"));
  }

  return {
    ...(customerId ? { customerId } : {}),
    ...(orderId ? { orderId } : {})
  };
}
